import React from "react";
import { Toggle, Typography } from "@c4c-web/ui";
import type {
  IUseAddressFormSetters,
  IUseAddressFormStates,
} from "../../../hooks";
import type { TranslationFn } from "../../../types";

interface IDefaultAddressToggleProps {
  addressFormSetters: IUseAddressFormSetters;
  addressFormStates: IUseAddressFormStates;
  t: TranslationFn;
}

export const DefaultAddressToggle: React.FC<IDefaultAddressToggleProps> = ({
  addressFormSetters,
  addressFormStates,
  t,
}) => {
  const setDefaultAddress = (value: boolean): void => {
    addressFormSetters.setOtherStates((prevStates) => ({
      ...prevStates,
      defaultAddress: value,
    }));
  };

  return (
    <div className="flex items-center justify-between">
      <Typography>{t("addressJourney.setAddressDefault")}</Typography>
      <Toggle
        checked={addressFormStates.otherStates.defaultAddress}
        onCheckedChange={setDefaultAddress}
        showIcon
      />
    </div>
  );
};
